/*********************
 * Mobillor Technologies Pvt. ltd. CONFIDENTIAL
 * __________________
 *
 *  Mobillor Technologies Pvt. Ltd.
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Mobillor Technologies Pvt. Ltd.
 * The intellectual and technical concepts contained
 * herein are proprietary to Mobillor Technologies Pvt. Ltd.
 * may be covered by Rebublic Of India and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Mobillor Technologies Pvt. Ltd.
 */

import { useEffect } from "react";
import { connect } from "react-redux";

// Dashboard example components
import SimpleBlogCard from "examples/Cards/BlogCards/SimpleBlogCard";

// Functions from store
import { getHomeTicketDetails } from "../../store";

// Cookies
import Cookies from "universal-cookie";
const cookies = new Cookies();

const TicketsHomePage = ({
  getHomeTicketDetails,
  homeTicketDetailsReducer,
}) => {
  let userData = cookies.get("loginDetailsForSupport");
  let token = userData?.token;
  let clientId = userData?.data?.clientId;

  useEffect(() => {
    getHomeTicketDetails(clientId, token);
  }, []);

  let issueDetails = homeTicketDetailsReducer.homeTickets
    ? homeTicketDetailsReducer.homeTickets
    : {};

  return (
    <SimpleBlogCard
      icon="contact_support"
      color="dark"
      title="Tickets"
      description={
        <span>
          <h4>To-Do Tickets : {issueDetails.todo}</h4>
          <h4>In-Progress Tickets : {issueDetails.inProgress}</h4>
          <h4>Pending Tickets : {issueDetails.pending}</h4>
          <h4>Completed Tickets : {issueDetails.completed}</h4>
        </span>
      }
    />
  );
};

const mapStateToProps = (state) => {
  return {
    supportHomePageReducer: state.supportHomePageReducer,
    homeTicketDetailsReducer: state.homeTicketDetailsReducer,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getHomeTicketDetails: (clientId, token) =>
      dispatch(getHomeTicketDetails(clientId, token)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(TicketsHomePage);
